module.exports = __webpack_public_path__ + "static/media/wellness.6127bdc6.jpg";